var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 44,
    rx: 8,
    fill: "#292929"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9091 22.0002H10M31.5 22.0002H27.5909M15.9125 17.1627L13.1488 14.3989M28.3512 29.6014L25.5875 26.8377M15.9125 26.8377L13.1488 29.6014M28.3512 14.3989L25.5875 17.1627",
    stroke: "#A1A1A1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7489 25.909C21.7857 25.909 22.78 25.4972 23.5131 24.7641C24.2462 24.031 24.658 23.0367 24.658 21.9999C24.658 20.9632 24.2462 19.9689 23.5131 19.2358C22.78 18.5027 21.7857 18.0908 20.7489 18.0908C19.7122 18.0908 18.7179 18.5027 17.9848 19.2358C17.2517 19.9689 16.8398 20.9632 16.8398 21.9999C16.8398 23.0367 17.2517 24.031 17.9848 24.7641C18.7179 25.4972 19.7122 25.909 20.7489 25.909Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "#A1A1A1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 28.8409V32.75M20.75 11.25V15.1591",
    stroke: "#A1A1A1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationDark);
export default __webpack_public_path__ + "static/media/notification-dark.8184cb712b3fc27507e797eea744d80e.svg";
export { ForwardRef as ReactComponent };